import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class PatTry extends Fragment {
    constructor() {
        super();
    }

    // eslint-disable-next-line no-unused-vars
    summarize(summaryContext, stringifier) {
        return new FragmentSummary("", "PAT:");
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.isPatPlay = true;
        summaryContext.down = 1;
    }
}
